import 'css-chunk:src/app/containers/Home/UsersView/UsersView.scss';export default {
  "UsersView": "_UsersView_yegxu_1"
};